import { render, staticRenderFns } from "./create_status.vue?vue&type=template&id=1476a280"
import script from "./create_status.vue?vue&type=script&lang=js"
export * from "./create_status.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports